export default "__VITE_ASSET__CFt8vgVN__"